import { Dispatch, useEffect, useState } from 'react';
// Components/ui
import { TextField } from '@mui/material';
import { style } from './style';
import StatusAdornment from '../../shared/StatusAdornment';
// Types
import type { ChangeEvent } from 'react';
import { ChannelType } from '@trii/types/dist/Common/Channels';
import { NewAddress } from '../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';
import { AdornmentStatus } from '../../shared/StatusAdornment/StatusAdornment';
import { SetStateAction } from 'react';
import { CheckContactAddressData } from '../../types/CheckContactAddressData';
import { useEditContactApi } from '../../../../../../../context/EditContactApiContext';
import { useTranslationContext } from '../../../../../../../context/TranslationContext';

interface AddressInputProps {
  data: NewAddress | IContactAddress;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    id: string,
    channelType: ChannelType,
  ) => void;
  setWarnings: Dispatch<SetStateAction<string[]>>;
}

const PhoneInput = ({ data, onChange, setWarnings }: AddressInputProps) => {
  const api = useEditContactApi();
  const t = useTranslationContext();
  const { id, channelType, address } = data;
  const [adornmentStatus, setAdornmentStatus] = useState<AdornmentStatus>('idle');
  const [lastSearch, setLastSearch] = useState(address);
  const addressIsSaved = !data.hasOwnProperty('isSaved');

  useEffect(() => {
    let timer = setTimeout(async () => {
      if (address !== '' && address !== lastSearch) {
        if (!api) {
          return;
        }

        setAdornmentStatus('loading');
        setLastSearch(address);

        const checkContactAddressData: CheckContactAddressData = {
          address,
          type: channelType,
        };

        try {
          const { success, warnings } = await api.checkContactAddress({
            data: checkContactAddressData,
          });

          setWarnings(warnings);

          success ? setAdornmentStatus('available') : setAdornmentStatus('unavailable');
        } catch {
          setWarnings([]);
          setAdornmentStatus('unavailable');
        }
      }
    }, 1700);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <TextField
        disabled={addressIsSaved}
        sx={style.addressField}
        size="small"
        label={t('global.number')}
        value={address}
        onChange={(e) => {
          onChange(e, id, channelType);
        }}
        variant="outlined"
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        className="smallInput"
        InputProps={{
          endAdornment: (
            <>
              <StatusAdornment status={adornmentStatus} />
            </>
          ),
        }}
      />
      {}
    </>
  );
};

export default PhoneInput;
